import { CameraItem } from './Camera';

export const CameraDefinitions = {
  'camera': CameraItem,
};  